import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Chip, Tooltip } from '@mui/material';
import type { MouseEventHandler } from 'react';
import classSet from 'react-classset';

import itemUtils from '@/utils/itemUtils';

import { Permission } from '../../enums';
import type { Item } from '../../models';
import type { Permissions } from '../../models/Permissions';
import { useModalContext } from '../VNModal/VNModalProvider';

export interface Iprops {
  item: Item;
  permissions: Permissions;
  hideStatus?: boolean;
  onClick?: MouseEventHandler<any> | null;
}

const FuelAssetThumbnail = ({ item, permissions, hideStatus = false, onClick = null }: Iprops) => {
  const modal = useModalContext();

  const onClickIngestWarnings = (e: Event, asset: Item) => {
    e.stopPropagation();

    switch (asset?.ingestWarnings[0]) {
      case 'no-audio':
        modal.onOpen(
          'Missing Audio Track',
          'xl',
          <div className="ingest-warning-modal">
            <div className="ingest-warning-modal-inner">
              <p>
                This video file does not have an audio track. It will not playout in the stream it is associated with if
                published. Please remove it and upload a corrected version. (Note: the file does not have to have audio, but it
                needs at least one audio track)
              </p>
            </div>
          </div>,
          asset.id
        );
        break;
      default:
    }
  };

  return (
    <div
      className={classSet({
        'fuel-asset-thumbnail': true,
        'collection-thumbnail': item?.source === 'ClipGroup' || item?.source === 'NestedChannel',
        'nested-channel-clip': item?.source === 'NestedChannel',
        'live-event-clip': item?.source === 'LiveEvent',
        'no-clickable': permissions && !permissions.has(Permission.EditAsset),
        [`thumbnail-border-${item?.clipStatusMarker}`]: hideStatus === false && item?.clipStatusMarker !== 'none',
      })}
      title={item?.differenceVariantCodesWithChannel ? `Missing variants: ${item?.differenceVariantCodesWithChannel}` : ''}
      onClick={(event) => {
        if (onClick) onClick(event);
      }}
    >
      <div className="thumbnail-container">
        {item?.ingestWarnings?.length > 0 && (
          <Tooltip title="click to view details" placement="top">
            <Button className="ingest-warning" onClick={(e) => onClickIngestWarnings(e, item)}>
              <FontAwesomeIcon icon={faTriangleExclamation} />
            </Button>
          </Tooltip>
        )}
        <img className="group-thumbnail" src={item?.thumbnailSrc} loading="lazy" />
        <img className="thumbnail" src={item?.thumbnailSrc} loading="lazy" />
        {item && <Chip className="clip-group-icon-chip" label={itemUtils.resolveSymbolicClipTagName(item)} size="small" />}
      </div>
    </div>
  );
};

export default FuelAssetThumbnail;
